import React from 'react';
import clsx from 'classnames';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import { MDSButton, MDSTheme } from '@marqvision/mds/core';
import { EditIcon } from '@marqvision/mds/icons';
import { useLanguage } from '~/hooks';
import { useBreakpoint } from '~/hooks';
import { useRouteNames } from '~/hooks';
import { Logger } from '../../utils';

interface IProps {
  glow?: boolean;
  className?: string;
  style?: React.CSSProperties;
  size?: 'small' | 'medium' | 'large' | 'extra_large';
}

const useStyles = makeStyles(() => ({
  link: { textDecoration: 'none' },
  button: {
    borderRadius: '100px',
    letterSpacing: 0,
    marginTop: 0,
    padding: '0 20px',
    transition: '250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    transitionProperty: 'background-color, color',
  },
  glow: {
    animation: '$glowButton 1.5s alternate infinite',
    animationTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      animationDirection: 'normal',
      animationIterationCount: 1,
      animationFillMode: 'forwards',
      '&.MuiButtonBase-root': {
        backgroundColor: 'white !important',
        color: MDSTheme.palette.blue[700],
        '& svg > path': {
          fill: MDSTheme.palette.blue[700],
        },
      },
    },
  },
  '@keyframes glowButton': {
    '0%': {
      boxShadow: 'none',
    },
    '100%': {
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.12), 0px 2px 24px #00A7F6, 0px 4px 80px #00A7F6, 0px -2px 8px #5CC7F9',
    },
  },
}));

const CTAButton = ({ glow = false, className, style, size }: IProps): JSX.Element => {
  const RouteNames = useRouteNames();
  const { Lang } = useLanguage();
  const classes = useStyles();

  const { getMediaQueryValue: mq } = useBreakpoint();

  return (
    <Link
      to={RouteNames.FileAnApplication}
      className={clsx(classes.link, className)}
      onClick={() =>
        Logger.track('clicked file an application', {
          Through: 'Button-File an application',
        })
      }
      style={style}
    >
      <MDSButton
        variant="fill"
        startIcon={<EditIcon />}
        color="lightblue"
        size={size || mq('medium', 'extra_large', 'extra_large')}
        className={clsx(classes.button, { [classes.glow]: glow })}
      >
        {Lang.FileAnApplication}
      </MDSButton>
    </Link>
  );
};

export default CTAButton;
